import React, { useState, forwardRef, useEffect, useImperativeHandle } from 'react';
import { Modal } from 'react-bootstrap';
import axios from "axios";
import { useNavigate } from "react-router-dom";
import swal from 'sweetalert';

const InviteCustomer = forwardRef((props, ref) => {
    const navigate = useNavigate();
    const [inviteModal, setInviteModal] = useState(false);
     const [dataemp, setDataemp] = useState([]);
    const [errors, setErrors] = useState('');
    const [loading, setLoading] = useState(false);

const today = new Date().toISOString().split("T")[0];
    const userdata1 = localStorage.getItem('USER_data');
    const userData = JSON.parse(userdata1);
    const userid = userData.id;  
    
    const [company, setCompany] = useState([]);
  const [employees, setEmployees] = useState([]);
    const fetchEmployees = async () => {
    try {
        const { data } = await axios.get(
            "https://suhba.education.com.ly/back/api/amilatexpences"
        );

       

        const temp = data.map(emp => ({
            ...emp,
            Amount: ""
        }));

        setEmployees(temp);

    } catch (error) {
        console.log(error);
    }
};
const handleAmountChange = (index, value) => {

    if (!/^\d*$/.test(value)) return;

    const temp = [...employees];

    temp[index].Amount = value;

    setEmployees(temp);

};
const handleSubmit = async (e) => {

    e.preventDefault();

    const employeeList = employees
        .filter(emp => emp.Amount !== "")
        .map(emp => ({
            EmployeeID: emp.EmployeeID,
            Amount: emp.Amount
        }));


    if (employeeList.length === 0) {

        swal("يرجى إدخال مبلغ لموظف واحد على الأقل");

        return;

    }

    const payload = {

        ExpenseDate: today,

        ExpenseTypeID: 36,

        CompanyID: company.CompanyID,

        UserID: userid,

        employees: employeeList

    };


    try {

        setLoading(true);

        await axios.post(
            "https://suhba.education.com.ly/back/api/amilatexpences",
            payload
        );

        swal("تم حفظ المرتبات بنجاح");

        props.parentFunction();

        setInviteModal(false);

        fetchEmployees();

    } catch (error) {

        console.log(error);

    } finally {

        setLoading(false);

    }

};
    useEffect(() => {
        const companyData = localStorage.getItem('companies');
        if (companyData) {
            const parsedData = JSON.parse(companyData);
            const singleCompany = Array.isArray(parsedData) ? parsedData[0] : parsedData;
            setCompany(singleCompany);
        }
    }, []);
    
    const [hallData, setHallData] = useState({
        Amount: '',
        ExpenseDate: '',
        ExpenseTypeID: '',
        EmployeeID: '',
        CompanyID: company.CompanyID,
        UserID: userid,
        status: '', // أضفنا هذا الحقل لأنه سيتم تخزين النص فيه
    });

    const [selectedTypeName, setSelectedTypeName] = useState(''); // لحفظ اسم النوع المختار
    const [loanText, setLoanText] = useState(''); // لتخزين نص القرض

    useEffect(() => {
         fetchEmployees();
    }, []);

    useEffect(() => {
        if (company.CompanyID && userid) {
            setHallData((prevData) => ({
                ...prevData,
                CompanyID: company.CompanyID,
                UserID: userid,
            }));
        }
    }, [company, userid]);
 
    
     

    useImperativeHandle(ref, () => ({
        showInviteModal() {
            setInviteModal(true);
        }
    }));
 
    // في حال كتب المستخدم نص القرض، نخزن القيمة داخل status
    

  

    

    const showInviteModal = () => {
        setInviteModal(false);
    };

    return (
        <>
            <Modal className="modal fade" id="exampleModal1" show={inviteModal} centered>
                <div className="modal-content">
                    <div className="modal-header">
                        <h1 className="modal-title fs-5" id="exampleModalLabel1"
                         >صرف مرتبات موظفي المطبخ</h1>
                                 

                        <button type="button" className="btn-close" style={{ marginLeft: 0 }} onClick={() => setInviteModal(false)}></button>
                    </div>
                    <form onSubmit={handleSubmit}>
  
    {/* Header */}
          

        <div className="card-body">

            {/* Information */}
            <div className="row mb-4">

                <div className="col-md-4">
                    <label className="form-label fw-bold">
                        تاريخ الصرف
                    </label>

                    <input
                        type="date"
                        className="form-control"
                        value={today}
                        disabled
                    />
                </div>

                <div className="col-md-6">
                    <label className="form-label fw-bold">
                        نوع المصروف
                    </label>

                    <input
                        className="form-control"
                        value="مرتبات موظفي المطبخ"
                        disabled
                    />
                </div>

                

            </div>

            {/* Employees Table */}

            <div  
  className="table-responsive"
    style={{
        maxHeight: "400px",
        overflowY: "auto",
    }}>
                <table className="table table-bordered table-hover align-middle" style={{height:'400px'}}>

  <thead
            className="table-primary"
            style={{
                position: "sticky",
                top: 0,
                zIndex: 10,
            }}>
                        <tr>

                            <th width="70">#</th>

                            <th>اسم الموظف</th>

                            <th width="220">
                                المبلغ
                            </th>

                        </tr>

                    </thead>

                    <tbody>

                        {employees.map((emp, index) => (

                            <tr key={emp.EmployeeID}>

                                <td>{index + 1}

                                      {emp.is_paid_today == 1 ? ( <i
                className="fa-solid fa-circle-check text-success mx-3"
                style={{ fontSize: "18px" }}
            ></i>):null}
                                </td>

                                <td>
                                    {emp.FirstName}
                                </td>

                                <td>

                                  <input
    type="number"
    className="form-control text-center"
    placeholder="أدخل المبلغ"
    value={emp.Amount}
    disabled={emp.is_paid_today == 1}
    onChange={(e) =>
        handleAmountChange(
            index,
            e.target.value
        )
    }
    style={{
        backgroundColor: emp.is_paid_today == 1 ? "#78ce99" : "white",
        cursor: emp.is_paid_today == 1 ? "not-allowed" : "text"
    }}
/>

                                </td>

                            </tr>

                        ))}

                    </tbody>

                </table>

            </div>

            {/* Footer */}

            <div className="d-flex justify-content-end mt-4">

                <button
                    className="btn btn-success btn-lg px-5"
                    onClick={handleSubmit}
                >
                     حفظ جميع المرتبات
                </button>

            </div>

        </div>

 
                          
                    </form>
                </div>
            </Modal>
        </>
    );
});

export default InviteCustomer;
